/*@ngInject*/
const ValidateRuleModalController = function ($rootScope, $scope, options, localization, coreConstant) {

    $scope.viewModel = {
        ruleText: options.ruleText,
        error: options.error,
        done: '',
        ruleTabSelected: options.ruleText && !options.error
    };

    localization.getTranslationByKey('ruleHeader').then(function (translations) {
        $scope.viewModel.done = _.get(translations, 'reviewRule.reviewRuleModal.ok');
    });

    $scope.$on(coreConstant.event.MODAL_CLOSING, function () {
        $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
    });

    $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);
};

angular.module('ums.configuration')
    .controller('validateRuleModalController', ValidateRuleModalController);
